import request from "@/utils/request";

// 查询增票信息
export function getInvoice() {
  return request({
    url: '/user/customer-invoice/h5/invoice',
    method: 'get',
  })
}
// 修改增票信息
export function updateInvoice(data) {
  return request({
    url: "/user/customer-invoice/h5/updateInvoice",
    method: "post",
    data,
  });
}
// 新增增票信息
export function addInvoice(data) {
  return request({
    url: "/user/customer-invoice/h5/addInvoice",
    method: "post",
    data,
  });
}

export function getCustomerInvoice() {
  return request({
    url: "/user/customer-invoice/h5/invoice",
    method: "get",
  });
}
